import { useEffect, useState } from "react";

const IMAGES = [
  "https://images.unsplash.com/photo-1561501900-3701fa6a0864",
  "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
  "https://images.unsplash.com/photo-1573843981267-be1999ff37cd",
  "https://images.pexels.com/photos/1493756/pexels-photo-1493756.jpeg",
];

export const HeroSlideshow = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % IMAGES.length), 5000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="absolute inset-0 overflow-hidden">
      {IMAGES.map((src, idx) => (
        <img key={src} src={src} alt="" aria-hidden
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ease-in-out"
          style={{ opacity: idx === i ? 1 : 0, transform: idx === i ? "scale(1.05)" : "scale(1)", transition: "opacity 1500ms ease-in-out, transform 6000ms ease-out" }} />
      ))}
    </div>
  );
};
